<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <div class="isCopy">
        <span class="warning" v-if="isCopy==2">{{$t('CopyFailed')}}<i class="el-icon-warning"></i></span>
        <span class="success" v-if="isCopy==1">{{$t('CopySuccessful')}}<i class="el-icon-success"></i></span>
      </div>
      <ul class="expressList">
        <li>
          <span>{{$t('Carrier')}}：</span>
          <span>{{list.ExpressName}}</span>
        </li>
        <li>
          <span>{{$t('Shipping')}}：</span>
          <span>{{$t('PayonDelivery')}}</span>
        </li>
        <li>
          <span>{{$t('Tracking')}}：</span>
          <span class="code">{{list.Express}}<i class="copy" @click="doCopy(list.Express)">{{$t('Copy')}}</i></span>
        </li>
        <li>
          <span>{{$t('ShippingAddresses1')}}：</span>
          <span>{{list.Country+list.Provice+list.City}} {{list.AddressDetail}} {{list.ZipCode}}<span>{{list.UserName}} {{list.Mobile}}</span></span>
        </li>
      </ul>
    </div>
  </el-dialog>
</template>
<script>
import { getInfo } from "@/api/public";
export default {
  name: 'viewexpress',
  components: {},
  data() {
    return {
      userInfo: getInfo(),
      isCopy:0,
      loading: false,
      dislogType: this.$enumInfo.dislogType,
      dialogClass: 'express',
    }
  },
  props: {
    list: {},
    title: String,
    domVisible: Boolean,
  },
  created() {},
  mounted() {},
  methods: {
    // 关闭
    closeDialog(val) {
      this.$emit('closeDialog', 'viewexpress', false)
    },
    doCopy(val) {
      let that=this;
      this.$copyText(val).then(function(e) {
        that.isCopy=1
      }, function(e) {
        that.isCopy=2
      })
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/user.css";

</style>



// WEBPACK FOOTER //
// src/components/dialog/viewexpress.vue